export const CommonDescription: React.FC = () => {
  return (
    <>
      <p>
        <span className="rte-standard">
          Покупайте товары для ремонта и обустройства дома сейчас, а оплату оставьте на потом — оформите кредит в одном из наших магазинов!
        </span>
      </p>
      <p>
        <span className="rte-standard">
          Кредитные программы представлены следующими банками или микрофинансовыми организациями
          (МФО-партнёрами): АО «Кредит Европа Банк» (Россия), КБ «Ренессанс Кредит» (ООО), АО «ОТП Банк», АО
          «Банк Русский Стандарт», ООО МФК «ДК ПЭЙ».
        </span>
      </p>
      <p>
        <span className="rte-standard">
          Выберите подходящий для вас банк или МФО и программу кредитования, и начните воплощать свои идеи в жизнь!
        </span>
      </p>
      <p>
        <span className="rte-standard">
          Важно: кредитные предложения от разных банков и их наличие в конкретном магазине могут отличаться —
          уточняйте подробности у наших консультантов.
        </span>
      </p>
    </>
  );
};
